// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___agE8Y","title":"style__title___8RxgA","subtitle":"style__subtitle___o3s-m","input":"style__input___367GB","inputPasswordContainer":"style__inputPasswordContainer___3UapY","inputPassword":"style__inputPassword___1WqZW","inputPasswordForgot":"style__inputPasswordForgot___15Jsc","inputError":"style__inputError___3nT3p","error":"style__error___2mDJA","button":"style__button___2SP_4","text":"style__text___BLQn3","textBold":"style__textBold___3exHx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/pin-verification/style.css
// module id = 1101
// module chunks = 0